import { MotifButton, MotifIcon, MotifModal, MotifModalBody, MotifModalFooter, MotifModalHeader } from "@ey-xd/motif-react";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import { CANCEL_BUTTON_VARIANT } from "@/components/Images/CommonImages";
import { useTranslation } from "react-i18next";

export default function WarningModal({onClose,showModal,description}:{onClose:()=>void,showModal:boolean,description:string}) {
      const {t}=useTranslation()
    
    return (<MotifModal
    onClose={() => onClose()}
    show={showModal}
    focusTrapOptions={{
      tabbableOptions: {
        displayCheck: "none",
      },
    }}
  >
    <div className="confirmationModalWrapper creditor_disabling_model">
      <MotifModalHeader
        headerIcon={
          <>
            <span
              style={{
                backgroundColor: "rgb(252, 245, 243)",
                borderRadius: "50px",
                padding: "5px 8px 2px 8px",
              }}
            >
              <MotifIcon
                iconFunction={IconoirWarningTriangle}
                strokeWidth="1"
                size="15"
                stroke="red"
              />{" "}
            </span>
            <span
              style={{
                fontSize: 16,
                display: "block",
                width: "100%",
                marginLeft: "10px",
              }}
            >
              {t("global.globalNotifications.warning")}
            </span>
          </>
        }
      ></MotifModalHeader>
      <MotifModalBody style={{ paddingTop: "0px" }}>
        <span style={{ fontWeight: "300" }}>
          {description}</span>
      </MotifModalBody>
      <MotifModalFooter>
        <MotifButton
          className=""
          onClick={() => onClose()}
          size="small"
          type="button"
          variant={CANCEL_BUTTON_VARIANT}
        >
          {t("global.globalActions.cancel")}
        </MotifButton>
      </MotifModalFooter>
    </div>
  </MotifModal>)
}